import styled from 'styled-components';

const StyledUpload = styled.div`
    .upload-text{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 50%;
        display: inline-block;
        vertical-align: middle;
        padding-left: 5px;
        border: 1px solid ${({ theme }) => theme.lightBorder};;
        border-radius: 5px 0px 0px 5px;
        padding: 5px 4px 4px 4px;
        border-right: 0;
        margin-right: -2px;
        margin-top: -2px;
    }
`;

export default StyledUpload;



// WEBPACK FOOTER //
// client/components/Upload/StyledUpload.js